/**
 * Ghost examples for every shaped input.
 *
 * A shaped input (a number with a fixed length or grouping, a date, a time,
 * an amount) shows one example of a filled value inside the empty box, the
 * way the platforms people already use do. It is a sample, not an
 * instruction: no «مثلاً», no sentence. Screens set
 * `placeholder={FIELD_EXAMPLE.mobile}` and write no other placeholder on a
 * text input, except search boxes and «انتخاب کنید» on a select.
 *
 * The figures are Persian, as everything the product shows. The IBAN is the
 * exception: its box carries «IR» and Latin digits with no spaces, so its
 * example looks like what the box will hold. A grouped number (mobile,
 * landline) is wrapped in a left to right isolate, so its groups keep their
 * order inside a right to left box.
 */

const LTR = (text: string) => `⁦${text}⁩`

export const FIELD_EXAMPLE = {
  /** شماره موبایل */
  mobile: LTR('۰۹۱۲ ۱۲۳ ۴۵۶۷'),
  /** کد ملی */
  nationalId: '۰۰۱۲۳۴۵۶۷۸',
  /** شناسه ملی شرکت */
  companyNationalId: '۱۰۱۰۱۲۳۴۵۶۷',
  /** کد پستی */
  postalCode: '۱۲۳۴۵۶۷۸۹۰',
  /** تلفن ثابت، با کد شهر */
  landline: LTR('۰۲۱ ۸۸۷۷ ۶۶۵۵'),
  /** کد اقتصادی */
  economicCode: '۴۱۱۱۲۲۳۳۴۴۵۵',
  /** شماره ثبت */
  registrationNo: '۱۲۳۴۵۶',
  /** شبا, as the box holds it: IR and 24 Latin digits, no spaces. */
  iban: 'IR160120000000001234567890',
  /** ایمیل */
  email: 'name@company.ir',
  /** تاریخ شمسی */
  date: '۱۴۰۵/۰۶/۲۰',
  /** تاریخ تولد، شمسی */
  birthDate: '۱۳۷۰/۰۱/۱۵',
  /** ساعت، ۲۴ ساعته */
  time: '۰۹:۳۰',
  /** وزن به کیلوگرم */
  weightKg: '۲۵,۰۰۰',
  /** مبلغ به ریال */
  priceRial: '۸,۱۵۰,۰۰۰',
} as const

export type FieldExampleKey = keyof typeof FIELD_EXAMPLE
